<template>
  <div class="product_list">
    <transition-group class="riclothes-products-container" tag="div" name="riclothes-product-animation">
      <RiClothesItemCard v-for="product in products" :key="product.id" :productItem="product"></RiClothesItemCard>
    </transition-group>
  </div>
</template>

<script>
import RiClothesItemCard from "@/components/RiClothesItemCard.vue";

export default {
  name: "ProductList",
  components: {
    RiClothesItemCard
  },
  data() {
    return {
      products: [],
      productAnimetionIndexCount: 0
    }
  },
  mounted() {
    document.title = "配布/販売物 - RiClothes Website";
  },
  created() {
    fetch("/products/product_list.json", { method: "GET" }).then(response => response.text()).then(text => {
      this.products = JSON.parse(text);
    });
  }
}
</script>

<style lang="scss" scoped>
  .riclothes-products-container {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
    align-content: flex-start;
  }

  .riclothes-product-animation-enter {
    opacity: 0;
  }

  .riclothes-product-animation-enter-active {
    transition: all 1s;
  }
</style>